import { Card, CardContent, Typography } from '@mui/material';
import Chart from 'react-google-charts';
import { ReportTypeAPI } from 'App';
import * as S from './ReportCard.styled';
import { getChartData, getChartHeight } from './ReportCard.utils';

type ReportCardPropsType = {
  report: ReportTypeAPI;
  partnerTargetProfile: string;
};

export function ReportCard({ report, partnerTargetProfile }: ReportCardPropsType) {
  return (
    <Card>
      <S.Anchor id={report.name} />
      <S.CardHeader title={report.name} success={report.name == partnerTargetProfile} />
      <CardContent>
        <Chart
          chartType='Timeline'
          data={getChartData(report.regions)}
          height={getChartHeight(report.regions)}
        />
        <Typography mb={2}>
          Will target <strong>{report.targetDuration}</strong>.
        </Typography>
        <S.Pre>{report.configuration}</S.Pre>
      </CardContent>
    </Card>
  );
}
